export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    width: 30,
    treeNode: true,
    fixed: 'left',
  },
  {
    field: 'defaultImageUrl',
    width: 80,
    title: that.$l('INDEX.table_label_image') || '图片',
    align: 'center',
    fixed: 'left',
    showHeaderOverflow: true,
    slots: { default: 'defaultImageUrl' },
  },
  {
    title: that.$l('table_label_goods') || '产品',
    headerAlign: 'center',
    align: 'left',
    minWidth: 220,
    showHeaderOverflow: true,
    slots: { default: 'showGoods' },
  },
  {
    title: that.$l('table_label_orderGoodsIdentify') || '客户产品识别编号',
    headerAlign: 'center',
    align: 'left',
    minWidth: 220,
    showHeaderOverflow: true,
    slots: { default: 'showGoodsIdentify' },
  },
  {
    title: that.$l('table_label_orderQty') || '订单数量',
    field: 'orderQty',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    isTotalColumn: true,
    slots: { default: 'orderQty' },
  },
  {
    title: that.$l('table_label_price') || '单价',
    field: 'price',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_subPrice') || '小计金额',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    formatter: ({ row }) => {
      const { orderQty, price } = row
      if (price == undefined || price == null) return ''
      return that.format(that.multiply(orderQty, price))
    },
  },
  {
    title: that.$l('table_label_ncNo') || 'NC编码',
    field: 'ncNo',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    slots: { edit: 'edit-ncNo', default: 'default-ncNo' },
    editRender: { enabled: true },
    showHeaderOverflow: true,
  },
]
